import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCarBattery, faTools, faCogs, faSnowflake, faBolt, faOilCan } from '@fortawesome/free-solid-svg-icons';

const ServicesSection = () => {
  const services = [
    { icon: faCarBattery, title: "Brake Services", description: "Complete brake repair, replacement and inspection services" },
    { icon: faTools, title: "Engine Diagnostics", description: "Advanced diagnostic services for engine performance issues" },
    { icon: faCogs, title: "Transmission Repair", description: "Expert transmission repair and fluid exchange services" },
    { icon: faSnowflake, title: "AC Services", description: "AC maintenance, repair and recharge services" },
    { icon: faBolt, title: "Electrical Systems", description: "Battery testing, alternator and electrical system repairs" },
    { icon: faOilCan, title: "Oil Changes", description: "Quick oil changes with high quality synthetic blends" }
  ];

  return (
    <section id="services" className="py-20 bg-gray-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <h2 className="text-3xl font-bold text-gray-900 mb-4">
            Our Auto Repair Services
          </h2>
          <p className="text-lg text-gray-600 max-w-2xl mx-auto">
            We offer comprehensive auto repair and maintenance services.
            Don't see what you need? We handle all types of automotive repairs.
          </p>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
          {services.map((service, index) => (
            <div key={index} className="bg-white rounded-xl shadow-sm p-6 hover:shadow-md transition-shadow">
              <div className="w-12 h-12 bg-primary rounded-lg flex items-center justify-center mb-4">
                <FontAwesomeIcon icon={service.icon} className="text-white text-xl" />
              </div>
              <h3 className="text-xl font-semibold text-gray-900 mb-2">{service.title}</h3>
              <p className="text-gray-600">{service.description}</p>
            </div>
          ))}
        </div>

        <div className="text-center mt-12">
          <p className="text-gray-500 text-sm mb-4">
            Don't see what you need? We handle all types of automotive repairs.
          </p>
          <a
            href="tel:3058210101"
            className="bg-primary text-white px-6 py-3 rounded-lg font-medium hover:bg-secondary transition-colors inline-block"
          >
            Call Now
          </a>
        </div>
      </div>
    </section>
  );
};

export default ServicesSection;